/**
 * NavigationAbortError is thrown intentionally to prevent route changes
 * when the user has unsaved changes. These errors should NOT be reported
 * to error monitoring services as they represent expected user behavior.
 */
export class NavigationAbortError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NavigationAbortError';
    // Maintains proper stack trace for where error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NavigationAbortError);
    }
  }
}
